import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'main-tai-chi-walking': {
			// ?safe&mock-data&utm_source=FB&country=US&area=main-tai-chi-walking&exp=web_main_tai_chi_walking_list_age_gender~1
			landing: {
				ids: ['loader-tai-chi-walking'],
			},
			funnel: {
				id: 'ob-tai-chi-walking-gender-selection-list',
				locale: ['en'],
			},
		},
	},
]

export default config
